import { eventEmit, isLocal } from './utils';

export enum LogType {
  LOG = 'LOG',
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  FATAL = 'FATAL',
  ARCHITECTURE = 'ARCHITECTURE',
  METRICS = 'METRICS',
}

export interface LogParams {
  loglevel?: LogType;
  kind?: LogKind[] | LogKind;
  aplicacion?: string;
  appVersion?: string;
  usersessionstart?: string;
  usersessionend?: string;
  usuario?: string;
  request_id?: string;
  response_id?: string;
  errorCode?: string;
  errorMessage?: string;
  payload?: { [key: string]: any };
  message: string;
  telemetry?: string;
}

/* LOG_TYPE */
export enum LogKind {
  LOG = 'log',
  METRIC = 'metric',
  MONITORING = 'monitoring',
}

/**
 * @method logger
 * @description internal architecture logger that was designed to be used inside architecture modules.
 *
 * 1- This logger in local is supposed to be visible only for architecture team
 * 2- To see logs you should have setted in your localStorage a variable env-absis with value  true
 * 3- All logs by default wont connect with logger and sent to ELK only the ones with second argument `send` as true
 * will end using the logger and depending of configuration going to server
 *
 * The rationale above explain the motivations of having a hidden logger that can be enable and disable by architecture
 *  Example : 
 * 
 * const opt = loglevel: 'ARCHITECTURE',
    name: ref.name,
    message: ref.message,
    payload: {},

    logger(opt)
 */
export const logger_v2 = /*@__PURE__*/ function (options: LogParams): void {
  /* istanbul ignore if */
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(() =>
      eventEmit('absisArchitectureLog', options)
    );
  } else {
    eventEmit('absisArchitectureLog', options);
  }
};

// Legacy
export function logger(msg: any, send = false, payload: any = {}): void {
  const local = isLocal();
  if (local && window.localStorage.getItem('debug-absis')) {
    (console as any).log.apply(console, [
      '%c' + 'absis log:',
      `background: #60db4c; color: white; padding: 2px 3px; border-radius: 2px; font-size: 0.9em; font-weight:500`,
      msg,
      payload,
    ]);
  } else if ((window as any).__ABSIS__ && !local && send) {
    (window as any).__ABSIS__.logger.architecture({ message: msg, payload });
  } else {
    eventEmit('absisArchitectureLog', { message: msg, payload });
  }
}
